import { createAction } from "redux-actions";

export const DEALER_LIST = "DEALER_LIST";
export const dealerList = createAction(DEALER_LIST);

export const DEALER_DELETE = "DEALER_DELETE";
export const dealerDelete = createAction(DEALER_DELETE);
